<ng-container *ngIf="this.hasPermission">

    <ng-container *ngIf="!(this.srvRpDesign.isMobile$ | async)">
        <button type="button" [ngStyle]="UIUtilityService.getHightLightButtonStyle()" class="btn btn-white d-flex flex-row align-items-center justify-content-center px-2 py-1 ms-2"
            (click)="onInsightClick($event)">
            <mat-icon svgIcon="falLightbulbOn" class="mx-auto my-1 icon-center" [ngStyle]="UIUtilityService.getBankTextColor()"></mat-icon>
            <span class="font-button-insight ms-2" [ngStyle]="UIUtilityService.getBankTextColor()" >{{ "PFM.INSIGHTS" | translate }}</span>
        </button>
    </ng-container>

    <ng-container *ngIf="(this.srvRpDesign.isMobile$ | async)">
        <button type="button" [ngStyle]="UIUtilityService.getHightLightButtonStyle()" class="btn btn-white d-flex flex-row align-items-center"
            (click)="onInsightClick($event)">
            <mat-icon svgIcon="falLightbulbOn" class="mx-auto my-1 icon-center" [ngStyle]="UIUtilityService.getBankTextColor()"></mat-icon>
            <span class="font-button-insight ms-2" [ngStyle]="UIUtilityService.getBankTextColor()" >{{ "PFM.INSIGHTS" | translate }}</span>
        </button>
    </ng-container>    

</ng-container>